// 9fbef606107a605d69c0edbcd8029e5d

import getAllPromotionsDataQuery from '@tcp/core/src/queries/getAllPromotions.query.graphql';
import getPromotionsDetailsQuery from '@tcp/core/src/queries/getBuyXSaveYPromotionsDetails.query.graphql';
import { executeStatefulGraphQLQuery } from '../../../handler/handler';

const PROMOTIONS_ABSTRACTOR = {
  allPromotionsResponse: (res) => {
    const data = {};
    res.forEach((promo) => {
      const promotionId = promo?.promotionId;
      const obj = {
        promotionId: promo?.promotionId,
        name: promo?.name,
        description: promo?.description,
        couponCode: promo?.couponCode,
        startDate: promo?.startDate,
        endDate: promo?.endDate,
        promoDisplayMsg: promo?.promoDisplayMsg,
        promoDisplayMsgPDP: promo?.promoDisplayMsgPDP,
        type: promo?.type,
        implicit: promo?.implicit,
        offerType: promo?.offerType,
        discountValue: promo?.discountValue,
        brand: promo?.brand,
      };
      data[promotionId] = obj;
    });
    return data;
  },
  promotionDetailsResponse: (res) => {
    const data = {};
    const promotionId = res.data.getPromotionDetails.couponDetails[0].code;
    const obj = {
      description: res.data.getPromotionDetails.couponDetails[0].description,
      legalText: res.data.getPromotionDetails.couponDetails[0].legalText,
      details: res.data.getPromotionDetails.couponDetails[0].details,
    };
    data[promotionId] = obj;
    return data;
  },
  getAllPromotionsData: () => {
    return executeStatefulGraphQLQuery({
      query: getAllPromotionsDataQuery,
      type: 'query',
    }).then((res) => {
      return PROMOTIONS_ABSTRACTOR.allPromotionsResponse(
        res?.data?.getAllPromotionsDetails?.promotionDetails
      );
    });
  },
  getPromotionDetailsData: (promotionID = '') => {
    return executeStatefulGraphQLQuery({
      query: getPromotionsDetailsQuery,
      variables: { couponCode: promotionID },
      type: 'query',
    }).then((res) => {
      return PROMOTIONS_ABSTRACTOR.promotionDetailsResponse(res);
    });
  },
};

export default PROMOTIONS_ABSTRACTOR;
